import { useMemo } from 'react';
import type { AgentType } from '../types/chat';

/**
 * Hook to get agent-specific suggested prompts
 * @param currentAgent - The currently selected agent
 * @returns Array of suggested prompts for the current agent
 */
export function useSuggestedPrompts(currentAgent: AgentType): string[] {
  return useMemo(() => {
    switch (currentAgent) {
      case 'jira-agile':
        return [
          'What are the high-priority items in this sprint?',
          'Show me overdue issues in the current sprint',
          'Give me a summary of completed tasks',
          'What are the blockers in our project?',
        ];
      case 'ado-agile':
        return [
          'What work items need attention in our backlog?',
          'Show me the sprint velocity trends',
          'List all work items due this week',
          'What are the team capacity metrics?',
        ];
      case 'knowledge-graph':
        return [
          'Who is the subject matter expert for this topic?',
          'What documentation exists for this process?',
          'Show me related resources and articles',
          'How does this connect to other systems?',
        ];
      default:
        return [
          'What can you help me with?',
          'Tell me more about this topic',
          'How do I get started?',
          'What are the next steps?',
        ];
    }
  }, [currentAgent]);
}
